<template>
  <section>
    <div class="mx-auto" style="width: 80%">
      <p class="title light font-weight-light">
        Furry, not a furry, from the area, or from the other side of the globe; we don’t care! Come join any number of
        our chats and have a great time. All chats follow these
        <router-link :to="{name: 'GeneralChatRules'}">basic guidelines and rules</router-link>.
        Each chat may have rules in addition and members of that group are expected to follow their rules.
      </p>
      <template v-for="(value, index) in telegramChats">
        <chat-card
          :chat="value"
          :stack="stack"
          :flip="index % 2 === 1"
          @rules="showChatRules(value)"
          @join="showJoinChat(value)"
        />
      </template>
    </div>

    <v-dialog
      max-width="1110px"
      v-model="chatRules"
    >
      <v-card>
        <v-card-title>
          <h2 v-if="selectedChat">
            {{selectedChat.name ? selectedChat.name : "Chat Rules" }}
          </h2>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text style="max-height: calc(75vh - 100px)" class="overflow-auto">
          <v-sheet height="100%" min-height="10px" width="90%" class="mx-auto">
            <chat-rules-display v-if="selectedChat" :chat="selectedChat" />
          </v-sheet>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="secondary"
            tile
            @click="chatRules = false"
          >
              Close
          </v-btn>
          <v-btn
            tile
            class="ml-auto"
            color="primary"
            @click="$router.push({name:'ChatRules', params: {id: selectedChat.id} })"
          >
            Open Page
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog
      max-width="600px"
      v-model="joinChat"
    >
      <v-card>
        <v-card-title>
          <h2 v-if="selectedChat">
            {{selectedChat.name ? selectedChat.name : "Join Chat" }}
          </h2>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text style="max-height: calc(75vh - 100px)" class="overflow-auto">
          <v-sheet height="100%" min-height="10px" width="90%" class="mx-auto">
            <join-chat-display v-if="selectedChat" :chat="selectedChat" />
          </v-sheet>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="secondary"
            tile
            @click="joinChat = false"
          >
            Close
          </v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>

  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import ChatCard from './components/ChatCard'
  import ChatRulesDisplay from "./modules/chatRules/components/ChatRulesDisplay";
  import JoinChatDisplay from "./components/JoinChatDisplay";
  import _ from 'lodash'

  export default {
    name: 'ChatsDashboard',
    components: {
        ChatCard,
        ChatRulesDisplay,
        JoinChatDisplay
    },
    data() {
      return {
          telegramChats: undefined,
          otherChats: undefined,
          stack: false,
          chatRules: false,
          joinChat: false,
          selectedChat: undefined
      }
    },
    watch: {
        getChats: {
            deep: true,
            handler(newValue) {
               this.sortChats(newValue);
            }
        }
    },
    computed: {
        ...mapGetters('site', ['getChats']),

    },
    methods: {
        ...mapActions('site', ['pullChats']),
        sortChats(chats) {
            if(!chats) {
                this.telegramChats = undefined;
                return;
            }

            const chatArray = Object.values(chats);
            chatArray.sort( (a,b) => {
                if(a.order && b.order)
                  return a.order - b.order;

                // prioritize chats with a defined order
                if (a.order) return -1;
                if (b.order) return 1;

                // Neither chat has an order, doesn't matter
                return 0
            });

            // Sort the chats into groups
            const telegram = chatArray.filter( chat => chat.type === 'telegram')
            const others = chatArray.filter(chat => chat.type !== 'telegram');

            // Assign groups to values
            if(telegram && telegram.length > 0)
                this.telegramChats = telegram;
            else
                this.telegramChats = undefined

            if(others && others.length > 0)
                this.otherChats = others;
            else
                this.otherChats = undefined;
        },
        windowSize(e) {
            const width = window.innerWidth;
            this.stack = !!(width && width <= 860);
        },
        showChatRules(chat) {
            this.chatRules = true;
            this.joinChat = false;
            this.selectedChat = chat;
        },
        showJoinChat(chat) {
            if(!chat || !chat.join)
                return;

            if(chat.join.type === 'link') {
                window.open(chat.join.content, '_blank')
            } else {
                this.joinChat = true;
                this.chatRules = false;
                this.selectedChat = chat;
            }
        }
    },
    async mounted () {
        const chats = await this.getChats;

        if(!chats)
           this.pullChats();
        else
            this.sortChats(chats);

        const width = window.innerWidth;
        this.stack = !!(width && width <= 860);

        window.addEventListener("resize", this.windowSize);
    },
    beforeDestroy () {
        window.removeEventListener("resize", this.windowSize);
    }
  }
</script>
<style>
 .wiki-quote {
   border-style: solid;
   border-width: 0 0 0 15px;
   border-color: #EF5350 !important;
 }
</style>
